import React, { useState } from 'react';
import { Divider, IconButton, Tooltip } from "@mui/material";
import { ContentCopy, CheckCircle } from "@mui/icons-material";
import Typography from '@mui/material/Typography';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';

const ReferralForm = ({ userData, HtmlTooltip, stakeData, claimButton, claimReward }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(userData.referralLink || "").then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    const steps = [
        {
            label: 'Get referral link',
            description: `Start by staking your OSCAR tokens. Once you've successfully staked, your account will automatically generate a unique referral link.`,
        },
        {
            label: 'Invite your friends',
            description: 'Share your referral link with your friends, or on social media. Encourage them to join the platform and stake their OSCAR tokens.',
        },
        {
            label: 'Earn Referral Bonuses Instantly',
            description: `When someone stakes using your referral link, you'll earn a percentage (${stakeData ? stakeData.referralRewardRate : 10}%) of their staked amount as a bonus.`,
        },
    ];

    const formStyle = {
        marginTop: 0,
        width: '100%',
    };

    const formStyleTip = {
        marginTop: 20,
        marginBottom: 50,
        marginLeft: window.innerWidth < 768 ? 0 : 25,
        width: '100%',
    };


    return (
        <>
            <div className="main details" style={{ marginTop: 0 }}>
                <form action="/buy-crypto-details" style={formStyle}
                    onSubmit={(e) => {
                        e.preventDefault();
                        claimReward();
                    }}>
                    <div className="main info" style={{ marginTop: 0 }}>
                        <Typography color="inherit" variant='h5' style={{color: "#119f24"}}>
                            Referral Program
                            <HtmlTooltip
                                title={
                                    <React.Fragment>
                                        <Typography color="inherit"  >Referral Program</Typography>
                                        <span >
                                            Earn rewards with our Referral Program! Share your unique link, invite friends, and unlock bonuses as they stake.
                                        </span>
                                    </React.Fragment>
                                }
                            >
                                <HelpOutlineIcon style={{ marginLeft: 5, width: 18, height: 18, marginBottom: 10 }} />
                            </HtmlTooltip>
                        </Typography>
                        <ul className="list" style={{ marginTop: 40 }}>
                            <li>
                                <div className="icon" style={{ backgroundColor: "#119f24" }}>
                                    <i style={{ color: "white" }} className={`fa fa-share-nodes`}></i>
                                </div>
                                <div className="content">
                                    <p>REFERRED FRIENDS</p>
                                    <h6 className="price">{userData ? userData.bonusCount : 0}</h6>
                                </div>
                            </li>
                            <li>
                                <div className="icon" style={{ backgroundColor: "#119f24" }}>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M15.8333 4.16667H4.16665C3.24617 4.16667 2.49998 4.91286 2.49998 5.83333V14.1667C2.49998 15.0871 3.24617 15.8333 4.16665 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1667V5.83333C17.5 4.91286 16.7538 4.16667 15.8333 4.16667ZM4.16665 2.5C2.3257 2.5 0.833313 3.99238 0.833313 5.83333V14.1667C0.833313 16.0076 2.3257 17.5 4.16665 17.5H15.8333C17.6743 17.5 19.1666 16.0076 19.1666 14.1667V5.83333C19.1666 3.99238 17.6743 2.5 15.8333 2.5H4.16665Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M10.8333 9.99967C10.8333 7.69849 12.6988 5.83301 15 5.83301H18.3333C18.7935 5.83301 19.1666 6.2061 19.1666 6.66634C19.1666 7.12658 18.7935 7.49967 18.3333 7.49967H15C13.6193 7.49967 12.5 8.61896 12.5 9.99967C12.5 11.3804 13.6193 12.4997 15 12.4997H18.3333C18.7935 12.4997 19.1666 12.8728 19.1666 13.333C19.1666 13.7932 18.7935 14.1663 18.3333 14.1663H15C12.6988 14.1663 10.8333 12.3009 10.8333 9.99967Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M15.8334 10.0003C15.8334 10.4606 15.4603 10.8337 15 10.8337C14.5398 10.8337 14.1667 10.4606 14.1667 10.0003C14.1667 9.54009 14.5398 9.16699 15 9.16699C15.4603 9.16699 15.8334 9.54009 15.8334 10.0003Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="content">
                                    <p>AVAILABLE BONUS</p>
                                    <h6 className="price">{userData ? userData.bonusDebt : 0} OSCAR</h6>
                                </div>
                            </li>
                            <li>
                                <div className="icon" style={{ backgroundColor: "#119f24" }}>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M15.8333 4.16667H4.16665C3.24617 4.16667 2.49998 4.91286 2.49998 5.83333V14.1667C2.49998 15.0871 3.24617 15.8333 4.16665 15.8333H15.8333C16.7538 15.8333 17.5 15.0871 17.5 14.1667V5.83333C17.5 4.91286 16.7538 4.16667 15.8333 4.16667ZM4.16665 2.5C2.3257 2.5 0.833313 3.99238 0.833313 5.83333V14.1667C0.833313 16.0076 2.3257 17.5 4.16665 17.5H15.8333C17.6743 17.5 19.1666 16.0076 19.1666 14.1667V5.83333C19.1666 3.99238 17.6743 2.5 15.8333 2.5H4.16665Z"
                                            fill="white"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M10.8333 9.99967C10.8333 7.69849 12.6988 5.83301 15 5.83301H18.3333C18.7935 5.83301 19.1666 6.2061 19.1666 6.66634C19.1666 7.12658 18.7935 7.49967 18.3333 7.49967H15C13.6193 7.49967 12.5 8.61896 12.5 9.99967C12.5 11.3804 13.6193 12.4997 15 12.4997H18.3333C18.7935 12.4997 19.1666 12.8728 19.1666 13.333C19.1666 13.7932 18.7935 14.1663 18.3333 14.1663H15C12.6988 14.1663 10.8333 12.3009 10.8333 9.99967Z"
                                            fill="white"
                                        />
                                        <path
                                            d="M15.8334 10.0003C15.8334 10.4606 15.4603 10.8337 15 10.8337C14.5398 10.8337 14.1667 10.4606 14.1667 10.0003C14.1667 9.54009 14.5398 9.16699 15 9.16699C15.4603 9.16699 15.8334 9.54009 15.8334 10.0003Z"
                                            fill="white"
                                        />
                                    </svg>
                                </div>
                                <div className="content">
                                    <p>CLAIMED BONUS</p>
                                    <h6 className="price">{userData ? userData.totalBonusClaimed : 0} OSCAR</h6>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="code" style={{ marginLeft: '3%' }}>
                        <p>Referral Link:</p>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                backgroundColor: 'inherit',
                                border: '1px solid #ddd',
                                borderRadius: '10px',
                                padding: '10px',
                                color: '#119f24',
                                fontSize: '14px',
                                width: '95%',
                                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', // Add subtle shadow for depth
                            }}
                        >
                            {(userData && userData.referralLink) || "No referral link available."}
                            {userData && userData.referralLink && (
                                <Tooltip title={copied ? "Copied!" : "Copy"}>
                                    <IconButton onClick={handleCopy} size="small" style={{ color: "inherit" }} >
                                        {copied ? (
                                            <CheckCircle style={{ color: "inherit" }} />
                                        ) : (
                                            <ContentCopy />
                                        )}
                                    </IconButton>
                                </Tooltip>
                            )}
                        </div>
                    </div>

                    <div className="group-button">
                        <button
                            disabled={(claimButton != 'CLAIM' && claimButton != "CONNECT WALLET")}
                            className="submit btn-action"
                            style={{
                                marginLeft: window.innerWidth < 768 ? '0' : '3%',
                                padding: window.innerWidth < 768 ? '10px 20px' : '10px 100px',
                                fontSize: window.innerWidth < 768 ? '14px' : '16px',
                                width: window.innerWidth < 768 ? '100%' : 'auto',
                            }}
                        >
                            {claimButton == 'CLAIM' ? userData ? parseFloat(userData.bonusDebt) > 0 ? `CLAIM (${userData.bonusDebt} OSCAR)` : claimButton : claimButton : claimButton}
                        </button>
                    </div>

                </form>
            </div>



            <div className="main details" style={{ marginTop: 20 }}>
                <form action="/buy-crypto-details" style={formStyleTip}>
                    <Typography variant="h5" style={{color:"#119f24"}}>How It Works?</Typography>
                    <Box sx={{ maxWidth: 400, marginTop: 2, marginBottom: 5 }}>
                        <Stepper orientation="vertical">
                            {steps.map((step, index) => (
                                <Step key={step.label} active>
                                    <StepLabel
                                        StepIconProps={{
                                            sx: {
                                                color: "#119f24 !important"  
                                            }
                                        }} 
                                    >
                                      <p style={{color: "#119f24"}}>{step.label}</p>   
                                    </StepLabel>
                                    <StepContent>
                                        <Typography sx={{ color: "inherit" }}>
                                            {step.description}
                                        </Typography>
                                    </StepContent>
                                </Step>
                            ))}
                        </Stepper>
                    </Box>


                    <Divider style={{ width: "90%" }} />

                </form>
            </div>


        </>
    );
};

export default ReferralForm;
